import type CK from '~/types/contentking';

import {
	useAccountTaxRateQuery,
} from './useAccountTaxRate.gql';

import useAccountPropertiesQuery from '~/hooks/useAccountPropertiesQuery';



function useAccountTaxRate(accountId: CK.AccountId | null) {
	const { data } = useAccountPropertiesQuery(
		useAccountTaxRateQuery,
		accountId,
	);

	if (data?.account && !data.account.billingDetails) {
		return {
			country: null,
			id: 'blank',
			isEstimate: false,
			rate: 0.0,
			type: null,
		};
	}

	return data?.account?.billingDetails?.tax ?? null;
}



export default useAccountTaxRate;
